import { useEffect } from 'react'
import { useAppState } from '../../../../../redux/reducer/content'
import { MAIN } from '../../../../../constants/shared/states/names'
import { image } from '../../../../../utils/data/baseUrl'
import { useModalsDataActions } from '../../../../../hooks/useModalsDataActions'
import { useUser } from '../../../../../redux/reducer/user'
import { defaultStore, stores } from '../../../../../translations'
import useServiceData from '../../../../../hooks/useServiceData'

function getWeekBeginning(date) {
  const d = new Date(date)
  const day = d.getDay()
  const diff = d.getDate() - day + (day === 0 ? -6 : 1)
  d.setDate(diff)
  d.setHours(0, 0, 0, 0)
  return d
}

export default function useReachLevelRewardDraw() {
  const state = useAppState()
  const { profile } = useUser()
  const { addModal } = useModalsDataActions()
  const { get, save } = useServiceData()

  const isAvailableStore = defaultStore === stores.ru || defaultStore === stores.kz
  // TODO изменить startDate после тестирования
  const startDate = new Date('2026-06-05T12:00:00')
  const endDate = new Date('2026-06-21T23:59:59')
  const now = new Date()
  const isDrawPeriod = now >= startDate && now <= endDate

  const weekBeginning = getWeekBeginning(now)
  const weekBeginningDate = weekBeginning.toISOString()

  const rewardDrawModalSeenWeekDate = get('rewardDrawModalSeenWeekDate')

  useEffect(() => {
    if (
      !isAvailableStore ||
      !isDrawPeriod ||
      !profile?.scorePrizes?.length ||
      state !== MAIN ||
      (rewardDrawModalSeenWeekDate && rewardDrawModalSeenWeekDate === weekBeginningDate)
    )
      return

    save('rewardDrawModalSeenWeekDate', weekBeginningDate)

    addModal({
      id: 'onboardingModal',
      type: 'onboardingModal',
      props: {
        image: image(`modals/level-reward-${defaultStore}.png`),
        title: 'levelRewardModal.modalTitle',
        description: 'levelRewardModal.modalDescription',
        buttons: [
          {
            attr: {
              text: 'levelRewardModal.modalButton',
              disposable: true,
              modalData: { action: 'close', data: { type: 'current' } },
            },
          },
        ],
      },
    })
  }, [profile?.scorePrizes, state])
}
